function TokenomicsInfo() {

    const data = [
        {
            percent: "10",
            title: "Community Allocation",
            info: "With 50 million coins set aside, PEPE3D prioritizes its community, rewarding the early adopters and funding initiatives for a robust ecosystem and seamless trading experience. This allocation represents our commitment to everyone who uses, promotes, and sees PEPE3D’s potential.",
            color: "bg-lime-600"
        },
        {
            percent: "30",
            title: "DEX & CEX listings",
            info: "Reserved for public listings, DEX and CEX. We allocate a significant portion to ensure broad accessibility and liquidity. DEXs provide transparency and direct wallet-to-wallet trading, while CEXs serve as gateways to larger markets, enhancing visibility and adoption.",
            color: "bg-red-400"
            
        },
        {
            percent: "59",
            title: "Presale Allocation",
            info: "Before our coins are available to the wider public, our crypto presale offers early supporters an exclusive opportunity to back our vision, often at a preferential rate. It's more than an initial fundraiser; it's about building a dedicated community.",
            color: "bg-yellow-300"
            
        },
        {
            percent: "1",
            title: "Team Allocation (Locked)",
            info: "We dedicate 5 million coins to our team, locked to align with $PEPE3D's long-term goals, showcasing our commitment to project success and team motivation.",
            color: "bg-sky-500"
        },
    ]

  return (
    <>
    {data.map(({percent, title, info, color})=>(
    <div className="w-[90vw] md:w-[22vw] text-white flex flex-col lg:p-2">
        <div className="flex gap-x-2 md:justify-start md:gap-x-4 mb-2 items-center text-sm md:text-base font-bold text-slate-100">
            <div className={`w-[28px] h-[14px] ${color} rounded`}></div>
            <span>{percent}%</span>
            <span>{title}</span>
        </div>
        <p className="text-balance text-neutral-100 text-sm md:text-base font-semibold">
            {info}
        </p>
    </div>
    ))}
    </>
  )
}

export default TokenomicsInfo